var generateNDigitNumber = function (numDigit) {
    var randomDecimal = Math.random().toPrecision(numDigit);
    return randomDecimal.slice(-numDigit);
};
export var generateTraceId = function (idLength) {
    if (idLength === void 0) { idLength = 8; }
    var uniqueId = generateNDigitNumber(idLength);
    return uniqueId + "_" + Date.now();
};
